import { onReady } from '../../utils/dom';

function findCartPanel(): HTMLElement | null {
  const panels = Array.from(document.querySelectorAll<HTMLElement>('div'));

  return (
    panels.find((element) => {
      const className = element.className || '';
      const text = (element.textContent || '').toLowerCase();

      return (
        typeof className === 'string' &&
        className.includes('fixed') &&
        className.includes('right-0') &&
        className.includes('top-0') &&
        className.includes('h-full') &&
        className.includes('overflow-y-auto') &&
        text.includes('carrello preventivi')
      );
    }) || null
  );
}

function forceScrollTop(panel: HTMLElement | null): void {
  window.scrollTo(0, 0);
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;
  if (panel) panel.scrollTop = 0;
}

function scrollAfterCartOpen(panel: HTMLElement | null): void {
  forceScrollTop(panel);

  window.setTimeout(() => {
    forceScrollTop(findCartPanel());
  }, 150);

  window.setTimeout(() => {
    const currentPanel = findCartPanel();
    if (currentPanel) currentPanel.scrollTop = 0;
  }, 350);
}

export function initCartPanelScrollPatch(): void {
  onReady(() => {
    let cartPanelWasPresent = false;

    const checkCartPanel = () => {
      const panel = findCartPanel();
      const cartPanelIsPresent = Boolean(panel);

      if (cartPanelIsPresent && !cartPanelWasPresent) {
        cartPanelWasPresent = true;
        scrollAfterCartOpen(panel);
      }

      if (!cartPanelIsPresent) cartPanelWasPresent = false;
    };

    const observer = new MutationObserver(checkCartPanel);
    observer.observe(document.body, { childList: true, subtree: true });
    checkCartPanel();
  });
}
